import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import uiReducer from './uiSlice';
import bonusReducer from './bonusSlice';

import referralReducer from './referralSlice';
import levelReducer from './levelSlice';
import siteReducer from './siteSlice';
import paymentReducer from './paymentSlice';
import toastReducer from './toastSlice';
import userWheelReducer from './userWheelSlice';

import { gamesApi } from './gamesApi';
import { paymentApi } from './paymentApi';
import { bonusesApi } from './bonusesApi';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    ui: uiReducer,
    bonus: bonusReducer,
    referral: referralReducer,
    level: levelReducer,
    site: siteReducer,
    payment: paymentReducer,
    toast: toastReducer,
    userWheel: userWheelReducer,
    [gamesApi.reducerPath]: gamesApi.reducer,
    [paymentApi.reducerPath]: paymentApi.reducer,
    [bonusesApi.reducerPath]: bonusesApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      gamesApi.middleware,
      paymentApi.middleware,
      bonusesApi.middleware,
    ),
  devTools: process.env.NODE_ENV !== 'production',
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
